import React from 'react'
import { Redirect } from 'common-tools/ReachRouter'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import Loadable from 'react-loadable'
import { LoadableLoading } from 'common-controls/App/LoadableLoading'
// import App from 'common-views/App/App'

const Me = Loadable({
  loader: () => import('common-views/Me/Me'),
  loading: (props) => {
    return <LoadableLoading {...props} />
  }
})

class MeRoutePlain extends React.Component {
  render () {
    const { SessionToken, location } = this.props

    if (!SessionToken) {
      return <Redirect from='/Me' to={`/Login?returnURL=${location ? location.pathname : ''}`} />
    }

    return React.createElement(Me, this.props)
  }
}

export const MeRoute = compose(
  ReduxWrapper([
    sh.SessionToken
  ])
)(MeRoutePlain)
